import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as Styled from './styles';
import { useAuth } from '../../hooks/useAuth';
import GoogleAnalyticsMetaDataObj from '../../helpers/googleAnalyticsHelpers/buildGoogleAnalyticsMetaDataObject';
import { sendMetadataEvent } from '../../helpers/googleAnalyticsHelpers/gaHelper';

export const TermsPage = () => {
    const { authStore } = useAuth();
    const googleAnalyticsMetadata = new GoogleAnalyticsMetaDataObj(
        authStore.user.uki_customerid,
        authStore.loggedIn,
        authStore.user['com.sbgcore.upgradable']
    );
    useEffect(() => {
        sendMetadataEvent(googleAnalyticsMetadata, 'Terms and Conditions');
    }, []);

    return (
        <Styled.TempTermsWrapper>
            <Styled.Title>ITV7 GOLD CUP SWEEPSTAKE COMPETITION:</Styled.Title>
            <Styled.SubTitle>TERMS AND CONDITIONS OF ENTRY</Styled.SubTitle>
            <Styled.Links>
                <li>
                    <a href="https://itv7.itv.com/home">
                        Return to ITV7 homepage
                    </a>
                </li>
                <li>
                    <Link to="/">Return to ITV7 Sweepstake homepage</Link>
                </li>
            </Styled.Links>
            <Styled.OrderedList>
                <li>
                    Terms and Conditions
                    <Styled.OrderedList>
                        <li>
                            These terms and conditions (&quot;
                            <strong>Terms and Conditions</strong>&quot;) will
                            apply to the ITV7 Gold Cup Sweepstake Competition
                            entered into, and as defined in Paragraph 4 (the
                            &quot;
                            <strong>Sweepstake</strong>
                            &quot;) below.
                        </li>
                        <li>
                            You will be deemed to have accepted these Terms and
                            Conditions and agreed to be bound by them when
                            entering the Sweepstake.
                        </li>
                        <li>
                            For the purposes of these Terms and Conditions, any
                            reference to &quot;you&quot;, or
                            &quot;entrant(s)&quot; are to persons who have
                            entered the Sweepstake in accordance with the terms
                            set out at Paragraph 5 (How to Enter).
                        </li>
                        <li>
                            Please note that Apple Inc. or Alphabet Inc. is in
                            no way linked or associated with this Sweepstake as
                            accessed via the ITV7 App (as defined below).
                        </li>
                        <li>
                            The Sweepstake may be featured and promoted on the
                            ITV Racing programme scheduled on the ITV TV
                            channels from time to time (the &quot;
                            <strong>Programme</strong>&quot;).
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    The Promoter
                    <Styled.OrderedList>
                        <li>
                            For the Sweepstake, the Promoter is both ITV
                            Consumer Limited of ITV White City, 201 Wood Lane,
                            London W12 7RU and Hestview Limited of One
                            Chamberlain Square Cs, Birmingham, United Kingdom,
                            B3 3AX jointly (together, the &quot;
                            <strong>Promoter</strong>&quot;).
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Eligibility
                    <Styled.OrderedList>
                        <li>
                            The Sweepstake is open to persons aged 18 or over
                            and resident in the UK, Channel Islands and Isle of
                            Man, except for:
                            <Styled.OrderedList>
                                <li>
                                    employees of the Promoter and/or each of
                                    their associated companies;
                                </li>
                                <li>
                                    employees of agents and/or suppliers of the
                                    Promoter and/or its associated companies who
                                    are professionally connected with the
                                    Sweepstake and/or its administration; or
                                </li>
                                <li>
                                    members of the immediate families or
                                    households of those specified in Paragraphs
                                    3.1.1 or 3.1.2 above
                                </li>
                            </Styled.OrderedList>
                        </li>
                        <li>
                            The Promoter may require entrants verify that they
                            meet the criteria in Paragraph 3 to the reasonable
                            satisfaction of the Promoter.
                        </li>
                        <li>
                            Where an entrant does not meet the criteria detailed
                            within these Terms and Conditions their entry will
                            not be valid and they will not be eligible to
                            receive the Prize.
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    The Sweepstake
                    <Styled.OrderedList>
                        <li>
                            ITV7 Gold Cup Sweepstake Competition is a
                            free-to-enter competition related to horse racing.
                        </li>
                        <li>
                            You will be randomly allocated one of the horses
                            entered in the Gold Cup race (&quot;
                            <strong>Runner</strong>&quot;). You cannot select
                            your own Runner.
                            <Styled.OrderedList>
                                <li>
                                    In the event you enter the Sweepstake before
                                    the initial allocation of Runners (at 2:00pm
                                    GMT on Wednesday 11th March 2026) you will
                                    be entered into the Sweepstake but
                                    won&apos;t be allocated a horse immediately.
                                    You will be allocated your horse at 2:00pm
                                    GMT on Wednesday 11th March 2026.
                                </li>
                                <li>
                                    In the event you enter the Sweepstake after
                                    the initial allocation of runners at 2:00pm
                                    GMT on Wednesday 11th March 2026, you will
                                    be allocated a horse immediately after you
                                    have entered the sweepstake.
                                </li>
                                <li>
                                    We shall aim to allocate the horses as close
                                    to the allotted times described above as
                                    possible, but are not responsible for any
                                    delays due to circumstances beyond our
                                    reasonable control.
                                </li>
                            </Styled.OrderedList>
                        </li>
                        <li>
                            If the Promoter becomes aware that your allocated
                            Runner will not partake in the Gold Cup race prior
                            to the Closing Time, the Promoter will randomly
                            allocate you another Runner in the Gold Cup race and
                            your entry will remain valid.
                        </li>
                        <li>
                            If the Promoter becomes aware that your allocated
                            Runner will not partake in the Gold Cup race after
                            the Closing Time you will not be reallocated a
                            Runner and you will be unable to enter the prize
                            draw.
                        </li>
                        <li>
                            You cannot change your allocated Runner or request
                            another Runner.
                        </li>
                        <li>
                            If your allocated Runner is declared as the official
                            winner of the Gold Cup race, as reported by the
                            Press Association, you will be entered into a prize
                            draw pool.
                        </li>
                        <li>
                            In the event that there is a dead heat between two
                            or more Runners in the race then the Runners which
                            are tied in the dead heat will each be treated as
                            having won the race. All entrants with winning
                            Runners will be entered into the prize draw pool.
                        </li>
                        <li>
                            One player will be randomly selected by the Promoter
                            from the prize draw pool to win the Prize (as
                            defined below).
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    How to Enter
                    <Styled.OrderedList>
                        <li>
                            The Sweepstake will be available for participants to
                            enter via the ITV7 mobile app (&quot;
                            <strong>ITV7 App</strong>&quot;), the ITV7 website
                            at{' '}
                            <a
                                href="https://itv7.itv.com/home"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://itv7.itv.com
                            </a>
                            , and the ITV7 Sweepstake website at{' '}
                            <a
                                href="https://itv7sweepstake.itv.com"
                                rel="noreferrer"
                            >
                                https://itv7sweepstake.itv.com
                            </a>
                            &nbsp;(collectively, the &quot;
                            <strong>Entry Points</strong>&quot;).
                        </li>
                        <li>
                            The Sweepstake will be open for entries from 10.00am
                            GMT on Thursday 5th March 2026 GMT (the &quot;
                            <strong>Opening Time</strong>&quot;) and will be
                            closed for entries at the start of the Gold Cup race
                            (the &quot;<strong>Closing Time</strong>&quot;,
                            currently scheduled to be 4.00pm GMT on Friday 13th
                            March 2026, but subject to change following an
                            alternative start time being declared).
                        </li>
                        <li>
                            Entry to the Sweepstake is free. Data charges may
                            apply (check with your internet service provider or
                            mobile network).
                        </li>
                        <li>
                            In order to enter the Sweepstake, you must:
                            <Styled.OrderedList>
                                <li>
                                    log-in to one of the Entry Points using a
                                    Sky Betting and Gaming user account (&quot;
                                    <strong>Account</strong>&quot;); and click
                                    to enter the Sweepstake,
                                </li>
                                <li>
                                    between the Opening Time and the Closing
                                    Time.
                                </li>
                            </Styled.OrderedList>
                        </li>
                        <li>
                            Before the Closing Time, entrants will be able to
                            view the Runner which has been allocated to them by
                            logging into their Account via the Entry Points.
                        </li>
                        <li>
                            Only one Account is permitted to be registered per
                            entrant. Only one entry is permitted per entrant. If
                            the Promoter believes that any one person has made
                            or may have made more than one entry to the
                            Sweepstake then the Promoter may disqualify all
                            entries that the Promoter believes have been made by
                            that person.
                        </li>
                        <li>
                            By registering for an Account, you authorise the
                            Promoter to conduct any identification, credit or
                            other verification checks that it may require
                            (either for its own purposes or as required by
                            applicable law or a regulatory body), including (but
                            not limited to) checking any or all of the details
                            you provide when registering or changing your
                            Account details. In particular, the Promoter may
                            verify that you are 18 (eighteen) years of age or
                            older and that you are resident in the country in
                            which you say you are resident. If the Promoter
                            discovers that you are under 18 years of age
                            following verification checks or that you have not
                            met any other verification criteria, your Account
                            shall be closed, and all entries will be
                            disqualified from participating in the Sweepstake
                            and/or receiving the Prize (as defined below).
                        </li>
                        <li>
                            The Promoter may supply the information that you
                            have provided to authorised credit reference
                            agencies, who may check such information against any
                            databases (public or private) to which they have
                            access and may keep a record of that check. The
                            checks will be for the purposes of confirming your
                            identification and for fraud detection and
                            prevention. For more information about how the
                            Promoter will process your information, please see
                            the Privacy and Cookie Policy at{' '}
                            <a
                                href="https://support.skybet.com/app/answers/detail/privacy-policy/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://support.skybet.com/app/answers/detail/privacy-policy/
                            </a>
                            .
                        </li>
                        <li>
                            If the Promoter has reasonable grounds to believe
                            that multiple Accounts have been opened by, or are
                            under the control of the same person, all such
                            Accounts shall be closed and all entries by such
                            person and/or Accounts held by such person will be
                            ineligible and will be disqualified from
                            participating in the Sweepstake and/or receiving the
                            Prize (as defined below). The Promoter may, at its
                            discretion, base its decision on the entrant’s email
                            address, name, IP address or any other information,
                            data, variables or factors. If a winning Account is
                            closed or suspended under this clause (5.9), the
                            Promoter will randomly re-select a new entrant from
                            the prize draw pool to win the Prize.
                        </li>
                        <li>
                            The Promoter does not accept any responsibility for
                            network, computer hardware or software failures of
                            any kind, which may restrict or delay the sending or
                            receipt of your entry.
                        </li>
                        <li>
                            Under no circumstances are you permitted to submit
                            your entry via email. Any entries submitted by email
                            will be automatically disqualified.{' '}
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Prize
                    <Styled.OrderedList>
                        <li>
                            The prize is a Prize Bundle worth £50,000 (&quot;
                            <strong>Prize</strong>&quot;), comprising:
                            <Styled.OrderedList>
                                <li>£40,000 cash;</li>
                                <li>
                                    a £5,000 holiday voucher with Totally Gifts
                                    Holiday Vouchers; and
                                </li>
                                <li>
                                    the following technology products:
                                    <Styled.OrderedList>
                                        <li>
                                            an Apple MacBook Pro 16” (2024) - M4
                                            Pro, 512 GB SSD, RAM 24 GB Silver;
                                        </li>
                                        <li>
                                            an Apple iPhone 17 Pro – 256 GB,
                                            Silver; and
                                        </li>
                                        <li>
                                            a Samsung S90F 65” OLED 4K Vision AI
                                            Smart TV 2025.
                                        </li>
                                    </Styled.OrderedList>
                                </li>
                            </Styled.OrderedList>
                        </li>
                        <li>
                            The &pound;5,000 holiday voucher will be issued to
                            Totally Gifts and is subject to their own terms and
                            conditions. Full T&Cs can be found at{' '}
                            <a
                                href="https://cdn.prod.website-files.com/68f623cd940246aa69eff4d8/6992f82e33e0821a680ea9be_Totally_Terms%20of%20Use.pdf"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://cdn.prod.website-files.com/68f623cd940246aa69eff4d8/6992f82e33e0821a680ea9be_Totally_Terms%20of%20Use.pdf
                            </a>
                        </li>
                        <li>
                            The Prize is awarded to one entrant who is:
                            <Styled.OrderedList>
                                <li>
                                    randomly allocated a winning Runner, and
                                </li>
                                <li>
                                    randomly selected from the pool of entrants
                                    allocated a winning Runner to receive the
                                    Prize.
                                </li>
                            </Styled.OrderedList>
                        </li>
                        <li>
                            If no entrant is allocated a winning Runner, no
                            Prize will be awarded.
                        </li>
                        <li>
                            If the race is abandoned, postponed or not completed
                            for any reason, or if no winning Runner(s) are
                            officially identified for the race for any reason
                            the Sweepstake will be cancelled and no Prize will
                            be awarded.
                        </li>
                        <li>
                            If the winning entrant is ineligible to win the
                            Prize, in accordance with these terms and conditions
                            the Promoter will randomly re-select a new entrant
                            from the prize draw pool to win.
                        </li>
                        <li>
                            There is no cash alternative. The Prize is
                            non-transferable and non-exchangeable.
                        </li>
                        <li>
                            Please note the Promoter will use elements of the
                            prize for filming purposes therefore boxes of some
                            items may be opened when delivered to the winner. As
                            a result of such filming and handling, items may
                            display minor cosmetic imperfections or signs of
                            handling that do not affect their functionality,
                            safety or overall quality.
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    <Styled.TextUnderline>
                        Entrants and Winner Verification
                    </Styled.TextUnderline>
                    <Styled.OrderedList>
                        <li>
                            The Promoter reserves the right in its sole
                            discretion to ask for evidence to verify the age,
                            identity and/or eligibility of an entrant at any
                            time, and to use any channels and methods available
                            to carry out checks of any details provided.
                        </li>
                        <li>
                            The winner of the Prize will be selected within one
                            week of the Sweepstake closing (&quot;
                            <strong>Winner Selection</strong>&quot;).
                        </li>
                        <li>
                            The winner of the Sweepstake (as determined in
                            accordance with the terms set out in Paragraph 6)
                            will be notified by the email or telephone number
                            registered on their Account within 14 days of the
                            Winner Selection.
                        </li>
                        <li>
                            It is your responsibility to ensure that you control
                            access to any phone number that you use to enter.
                            The Promoter shall not be responsible for any loss
                            you suffer as a result of the Promoter dealing in
                            good faith with anyone other than you who has access
                            to any such number (or any device using any such
                            number).
                        </li>
                        <li>
                            It is each entrant&apos;s sole responsibility to
                            ensure that their contact details are up to date.
                        </li>
                        <li>
                            The winner will be required to verify (with evidence
                            satisfactory to the Promoter) their:
                            <Styled.OrderedList>
                                <li>age;</li>
                                <li>identity;</li>
                                <li>residence; and</li>
                                <li>
                                    any other requested verification
                                    information,
                                </li>
                            </Styled.OrderedList>
                            in each case to the satisfaction of the Promoter
                            before they are eligible to receive the Prize.
                        </li>
                        <li>
                            The Promoter may withhold delivery of the Prize
                            until it has received satisfactory verification from
                            the winner. Failure to provide such satisfactory
                            verification in a timely manner may result in a
                            delay in the delivery of the Prize. Failure to
                            provide such satisfactory verification altogether
                            may result in forfeiture of the Prize.
                        </li>
                        <li>
                            To receive the Prize, the winner must provide a UK,
                            Isle of Man or Channel Islands address for delivery
                            of the Prize.
                        </li>
                        <li>
                            Any public announcement made regarding the winner
                            (including on ITV properties (TV, online etc.) is
                            pending verification unless otherwise stated and
                            should not be considered final confirmation.
                        </li>
                        <li>
                            If the winning entrant is, for whatever reason:
                            <Styled.OrderedList>
                                <li>not able to accept the Prize;</li>
                                <li>
                                    not able to verify their registration
                                    information to the satisfaction of the
                                    Promoter; or
                                </li>
                                <li>
                                    found to have breached these Terms and
                                    Conditions by the Promoter;
                                </li>
                            </Styled.OrderedList>
                            then the entrant will be disqualified and the Prize
                            will be forfeited.
                        </li>
                        <li>
                            If a winner of the Prize cannot be contacted in
                            accordance with these Terms and Conditions within
                            fourteen (14) Calendar Days of Winner Selection,
                            then the Prize winner will be reallocated and a new
                            winner will be randomly selected. This process will
                            be repeated until a winner is successfully
                            contacted.
                        </li>
                        <li>
                            The winner is required to comply with all reasonable
                            instructions and requirements as may be specified by
                            the Promoter to receive and/or take up the Prize.
                            The Promoter will not be liable where the winner
                            fails to comply with such instructions, and such
                            failure may result in forfeiture of the Prize.
                        </li>
                        <li>
                            The winner may be required to provide their
                            signature as proof of their agreement to relevant
                            waivers, releases and/or consents when taking up the
                            Prize.
                        </li>
                        <li>
                            The Promoter may refuse to provide the Prize, or may
                            seek recovery of the Prize, in the event of
                            non-entitlement under these Terms and Conditions or
                            an entrant&apos;s fraud or dishonesty.
                        </li>
                        <li>
                            The Promoter&apos;s decision is final and legally
                            binding on all entrants in relation to all aspects
                            of the Sweepstake including (without limitation)
                            allocation of the Prize and no correspondence will
                            be entered into.
                        </li>
                        <li>
                            Entries that do not comply in full with these Terms
                            and Conditions will be disqualified and will not be
                            eligible to receive the Prize. In this instance, the
                            Promoter reserves the right to re-draw a new winner.
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Prize fulfilment
                    <Styled.OrderedList>
                        <li>
                            NFE Events will coordinate the delivery of all tech
                            related prizes via a designated courier service.
                            Delivery will take place on a mutually agreed date,
                            and the winner will be responsible for ensuring that
                            someone is available to receive the parcel at the
                            nominated address. NFE Events accepts no liability
                            for delays caused by the courier or for failed
                            delivery attempts resulting from incorrect or
                            incomplete delivery information provided by the
                            winner. The voucher element of the prize will be
                            issued electronically and sent directly to the
                            winner’s nominated email address. It is the winner’s
                            responsibility to ensure that a valid and accessible
                            email address is supplied.
                        </li>
                        <li>
                            If the winner selects for the prize to be delivered
                            to their home address, the winner must provide a UK,
                            Isle of Man or Channel Islands address for delivery
                            of the prize. The Promoter will not deliver to any
                            address outside the UK, Isle of Man or Channel
                            Islands.
                        </li>
                        <li>
                            If the winner cannot provide all correct and valid
                            documentation required within a timely manner of
                            being contacted by the Promoter, the Promoter
                            reserves the right to disqualify the winner, in
                            which case the Prize will be forfeited.
                        </li>
                        <li>
                            Personal Data may be shared with NFE Events solely
                            for the purpose of Prize administration and/or
                            delivery.
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Marketing messages
                    <Styled.OrderedList>
                        <li>
                            From time to time you may be presented with the
                            opportunity to opt in to receive emails and/or (for
                            users of the ITV7 App) push notifications to notify
                            you of the opening of other ITV7 competitions. You
                            can opt out of receiving the emails at any time by
                            by navigating to the bottom of ITV7 emails and
                            following the link where it states “to unsubscribe
                            from ITV7, click here”. You can opt out of receiving
                            the push notifications by adjusting the settings on
                            your device.
                        </li>
                        <li>
                            From time to time you may also be presented with the
                            opportunity to opt in to receive marketing messages
                            from Sky Bet, (“Sky Bet”). You can opt out of
                            receiving these by navigating to the bottom of Sky
                            Bet emails and following the link where it states
                            “to unsubscribe from Sky Bet, click here”.
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Publicity &amp; privacy{' '}
                    <Styled.OrderedList>
                        <li>
                            If you enter the Sweepstake, you agree that the
                            Promoter and/or the producers of the Programme may
                            include and/or announce on: (i) the Entry Points;
                            (ii) social media platforms; (iii) the Programme;
                            and/or (iv) elsewhere your first name, general
                            location and details of the Prize that you have won.
                            If you do not want your name and location to be
                            published by the Promoter and/or the producers of
                            the Programme or would like reduced information
                            published, please contact{' '}
                            <a href="mailto:itvihelp@itv.com">
                                itvihelp@itv.com
                            </a>
                            &nbsp;and{' '}
                            <a href="mailto:itv7.sbg@skybet.com">
                                itv7.sbg@skybet.com
                            </a>
                            .
                        </li>
                        <li>
                            For more information about how the Promoter will
                            process your information, please see the Privacy and
                            Cookie Policy at{' '}
                            <a
                                href="https://support.skybet.com/app/answers/detail/privacy-policy/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://support.skybet.com/app/answers/detail/privacy-policy/
                            </a>
                            .{' '}
                        </li>
                        <li>
                            Where ITV uses your personal data as part of a
                            Broadcast Competition, particularly, in relation to
                            entrants who win, are disqualified and/or complain,
                            ITV will use any such information in line with ITV
                            Consumer Ltd’s Privacy & Cookie Information
                            (available at:{' '}
                            <a
                                href="https://www.itv.com/terms/articles/itv-privacy) and/or any other applicable ITV privacy"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://www.itv.com/terms/articles/itv-privacy)
                                and/or any other applicable ITV privacy
                            </a>
                            ) and/or any other applicable ITV privacy notice
                            which will be provided to you when required by
                            applicable laws. For example, where any public
                            announcements about winners are made within ITV
                            properties as set out in section 10.1 above, the
                            applicable privacy notice will be:{' '}
                            <a
                                href="https://www.itv.com/_data/documents/pdf/ITV_Broadcasting_Privacy_Notice.pdf."
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://www.itv.com/_data/documents/pdf/ITV_Broadcasting_Privacy_Notice.pdf.
                            </a>
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Customer Support
                    <Styled.OrderedList>
                        <li>
                            All customer support enquiries should be directed to
                            Sky Betting and Gaming, by:
                            <Styled.OrderedList>
                                <li>
                                    Sending an email to{' '}
                                    <a href="mailto:itv7.sbg@skybet.com">
                                        itv7.sbg@skybet.com
                                    </a>
                                </li>
                            </Styled.OrderedList>
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Privacy &ndash; supplemental
                    <Styled.OrderedList>
                        <li>
                            Information and data which is provided by you when
                            you enter the Sweepstake will be held by the
                            Promoter and may be used by the Promoter, the
                            producer of the Programme and their service
                            providers, network operators, suppliers and
                            contractors for the purposes of administering the
                            Sweepstake and/or fulfilling the Prize. You agree
                            that this includes without limitation that they may
                            contact you if there is an issue with the Sweepstake
                            and/or your entry.
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Miscellaneous
                    <Styled.OrderedList>
                        <li>
                            The Promoter reserves the right to modify these
                            Terms and Conditions from time to time for a number
                            of reasons, including in order to comply with
                            applicable laws and regulations.
                        </li>
                        <li>
                            In the event of any fault, mistake, misunderstanding
                            or dispute concerning the operation of any part of
                            the Sweepstake, the Promoter reserves the right to
                            cancel the Sweepstake and decide that no Prize of
                            any size will be awarded. The decision of the
                            Promoter shall be final.
                        </li>
                        <li>
                            Any entrant and/or winner must comply with any
                            directions given to him or her by the Promoter and
                            with all relevant laws, rules and regulations.
                            Failure to comply may result in an invalid entry
                            and/or forfeiture of the Prize.
                        </li>
                        <li>
                            The Promoter is committed to operating the
                            Sweepstake fairly and to preventing abuse of its
                            systems, as well as those of its agents and
                            sub-contractors. For this reason, the Promoter
                            reserves the right to disqualify entries if it has
                            reasonable grounds to suspect, having regard to all
                            the circumstances and information available at the
                            relevant time, any of the following:
                            <Styled.OrderedList>
                                <li>
                                    entries have been made in breach of these
                                    Terms and Conditions; or
                                </li>
                                <li>
                                    there has been any activity which the
                                    Promoter considers is designed to provide an
                                    unfair advantage.
                                </li>
                            </Styled.OrderedList>
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Liability
                    <Styled.OrderedList>
                        <li>
                            Nothing in these Terms and Conditions shall exclude
                            or limit the Promoter&apos;s liability for death or
                            personal injury caused by the Promoter&apos;s staff
                            or suppliers&apos; negligence or for fraud or for
                            any other liability which cannot be limited or
                            excluded by law or regulation.
                        </li>
                        <li>
                            The Promoter cannot guarantee that the Sweepstake
                            will be free from errors or omissions nor that it or
                            the Entry Points will be available uninterrupted and
                            in a fully operating condition.
                        </li>
                        <li>
                            The Sweepstake, or some or all of the Entry Points,
                            may be suspended without notice in the case of any
                            problem with any network or line, system, server,
                            software, or for any technical malfunction or
                            failure, maintenance or repair or for reasons
                            reasonably beyond the control of the Promoter. The
                            Promoter does not accept responsibility where all or
                            any part of the Sweepstake and/or any Entry Points
                            are suspended, discontinued, modified or changed in
                            any way.
                        </li>
                        <li>
                            The Promoter does not accept responsibility for any
                            fault, malfunction, damage, loss or disappointment
                            suffered by you as an entrant howsoever arising from
                            participating in the Sweepstake or from accepting
                            any Prize whether due to any error or omission by
                            the Promoter.
                        </li>
                        <li>
                            The Promoter is not responsible for any damage or
                            loss caused to you (i) which is not reasonably
                            foreseeable to you and to the Promoter when you
                            enter the Sweepstake, or (ii) is reasonably
                            foreseeable to you and to the Promoter on entry but
                            is only indirectly related to you entering or
                            participating in the Sweepstake.
                        </li>
                        <li>
                            The Promoter does not accept responsibility in the
                            event that any entry is lost, delayed or not
                            properly received, registered or recorded or for any
                            disruption, delay or misdirection of any entry.
                        </li>
                        <li>
                            The Promoter reserves the right to amend without
                            prior notice any element of the Sweepstake for
                            reasons beyond its reasonable control, including but
                            not limited to the unavailability of the Sweepstake
                            entry platform before the closing date, or for
                            strike, lock-out, labour dispute, illness, act of
                            God, natural disaster, adverse weather conditions,
                            war, riot, civil commotion, accident, epidemic,
                            pandemic, malicious damage, fire, flood and/or
                            storm, compliance with law or governmental order,
                            rule, regulation or direction, breakdown of plant,
                            machinery or transportation. The Promoter is not
                            responsible for any loss or damage caused as a
                            result of any of these occurrences.
                        </li>
                        <li>
                            You agree to reimburse the Promoter in respect of
                            any damages suffered by the Promoter or any losses
                            by Promoter resulting from any claim made by a third
                            party in each case in respect of any matter arising
                            from your participation in the Sweepstake in breach
                            of these Terms and Conditions or from your violation
                            of any applicable law or regulation.
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Governing law/jurisdiction
                    <Styled.OrderedList>
                        <li>
                            These Terms and Conditions shall be exclusively
                            governed by and construed in accordance with the
                            laws of England and Wales (unless the entrant is a
                            Scottish or Northern Irish resident in which case
                            he/she may choose the law of their residence) and
                            you irrevocably submit to the exclusive jurisdiction
                            of the courts of England and Wales (unless the
                            entrant is a Scottish or Northern Irish resident in
                            which case he/she may choose the courts of their
                            residence) in relation to any claim or dispute
                            relating in any way to the Sweepstake.
                        </li>
                    </Styled.OrderedList>
                </li>
                <li>
                    Accessibility
                    <Styled.OrderedList>
                        <li>
                            If you require any information to be provided in an
                            alternative format for accessibility reasons, the
                            Promoter will be happy to discuss your requirements
                            and endeavor to provide a suitable alternative.
                        </li>
                        <li>
                            The ITV7 Racing and ITV Racing word marks and logos
                            are trademarks of ITV Rights Limited.
                        </li>
                        <li>
                            These Terms and Conditions were last updated on 19th
                            February 2026.
                        </li>
                    </Styled.OrderedList>
                </li>
            </Styled.OrderedList>
        </Styled.TempTermsWrapper>
    );
};

export default TermsPage;
